<div class="modal-header">
  <h4 class="modal-title">Usuarios Activos</h4>
</div>
<div class="modal-body">
  <table class="table">
    <caption>
      Usuarios
    </caption>
    <thead>
      <tr>
        <th>Correo Electrónico</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let correo of datos">
        <td>{{ correo }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">Confirmar</button>
  <button class="btn btn-danger" (click)="close()">Close</button>
</div>
